'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { Checkbox } from '@pickleballinc/react-ui';
import { useForm } from 'react-hook-form';

import { ActionButtons } from '@/components/molecules';
import { ApproveDeclineRequestData, approveDeclineRequestSchema } from '@/entities';

interface ApproveDeclineRequestProps {
	fullName: string;
	teamName: string;
	onSubmit: (data: ApproveDeclineRequestData) => void;
	onClose: () => void;
}

export const ApproveDeclineRequestForm = ({ fullName, onSubmit, onClose, teamName }: ApproveDeclineRequestProps) => {
	const form = useForm<ApproveDeclineRequestData>({
		resolver: zodResolver(approveDeclineRequestSchema),
		defaultValues: {
			approvePlayerRequest: false,
			declinePlayerRequest: false
		}
	});

	const { formState, handleSubmit, setValue, watch } = form;

	const isApproveChecked = watch('approvePlayerRequest');
	const isDeclineChecked = watch('declinePlayerRequest');

	return (
		<>
			<form onSubmit={handleSubmit(onSubmit)}>
				<p className="py-4 text-lg font-semibold text-gray-500">
					{fullName} is requesting to join {teamName}
				</p>

				<div className="flex items-center">
					<Checkbox
						theme="orange"
						className="size-5 cursor-pointer"
						name="approvePlayerRequest"
						size="md"
						checked={isApproveChecked}
						onChange={(e) => {
							setValue('approvePlayerRequest', e.target.checked);
							setValue('declinePlayerRequest', false);
						}}
					/>
					<p className="pl-2">Approve - Add player to my team</p>
				</div>
				<div className="flex items-center pt-4">
					<Checkbox
						theme="orange"
						className=" size-5 cursor-pointer"
						name="declinePlayerRequest"
						size="md"
						checked={isDeclineChecked}
						onChange={(e) => {
							setValue('declinePlayerRequest', e.target.checked);
							setValue('approvePlayerRequest', false);
						}}
					/>
					<p className="pl-2">Decline this request</p>
				</div>

				<ActionButtons
					className="flex place-self-end !px-[10px] !py-[16px]"
					closeButtonClassName="w-full"
					submitButtonClassName="w-full !bg-orange-500 hover:!bg-orange-700 text-white disabled:!bg-darkorange-300"
					onClose={onClose}
					submitButtonText="Save"
					closeButtonText="Cancel"
					submitButtonDisabled={formState.isSubmitting}
				/>
			</form>
		</>
	);
};
